import { NgModule, TransferState } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthExpiredInterceptor } from './core/auth/auth-expired.interceptor';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app.component';
import {CommonModule, registerLocaleData} from "@angular/common";
import localeFr from '@angular/common/locales/fr';
import {JwtModule} from "@auth0/angular-jwt";
import { BrowserModule } from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {translateBrowserLoaderFactory} from "./translate-browser.loader";
import {AppRoutingModule} from "./app-routing.module";
import {RouterModule} from "@angular/router";
import {AuthService} from "./core/auth/auth.service";

export function tokenGetter() {
    return localStorage.getItem("access_token");
}

@NgModule({ declarations: [
        AppComponent,
        // , MomentModule
    ],
    exports: [RouterModule],
    bootstrap: [AppComponent], imports: [TranslateModule.forRoot({
            defaultLanguage: 'fr',
            loader: {
                provide: TranslateLoader,
                useFactory: translateBrowserLoaderFactory,
                deps: [HttpClient, TransferState]
            }
        }),
        RouterModule,
        HttpClientModule,
        CommonModule,
        FormsModule,
        /*  BsDropdownModule.forRoot(),*/
        JwtModule.forRoot({
            config: {
                tokenGetter: tokenGetter,
                allowedDomains: [
                    'localhost:8000',
                    'api.akces.fr',
                    'dev-api.akces.fr'
                ],
                disallowedRoutes: [],
            },
        }),
        BrowserAnimationsModule,
        AppRoutingModule,
        BrowserModule,
        NgbModule], providers: [
        AuthService,
        provideHttpClient(withInterceptorsFromDi()),
        // Détecte les sessions JWT expirées sur TOUS les appels HTTP et
        // déclenche un logout automatique. Évite que chaque composant admin
        // doive gérer le cas localement.
        { provide: HTTP_INTERCEPTORS, useClass: AuthExpiredInterceptor, multi: true },
    ] })
export class AppModule { }
registerLocaleData(localeFr, 'fr');
